import React, {cloneElement, useEffect, useState} from "react";
import {
    Car,
    CheckList,
    FastDelivery,
    OnWay,
    TrackingActiveLine,
    TrackingGrayLine,
    TrackingRedLine
} from "../../assets/icons";
import {useLanguage} from "../../hooks/LanguageContext";
import BookingInfoStep1 from "./BookingInfoStep1";
import SenderAndReceiverInfoStep2 from "./SenderAndReceiverInfoStep2";
import VehicleInfoStep3 from "./VehicleInfoStep3";
import apiService from "../../services/apiService";

const BookingForm = ({dataFromHomePage = null}) => {
    const { direction, language } = useLanguage();
    const steps = [
        { id: 1, title_ar: "معلومات الشحن", title_en: "Shipping Information", subtitle_ar: "المرحلة 1",  subtitle_en: "Phase 1",  icon : <OnWay />},
        { id: 2, title_ar: "معلومات الشاحن", title_en: "Sender Information", subtitle_ar: "المرحلة 2", subtitle_en: "Phase 2",  icon :<CheckList />  },
        { id: 3, title_ar: "معلومات السياره", title_en: "Vehicle Information", subtitle_ar: "المرحلة 3",  subtitle_en: "Phase 3",  icon : <Car />},
        { id: 4, title_ar: "الدفع", title_en: "Payment", subtitle_ar: "المرحلة 4", subtitle_en: "Phase 4", icon : <FastDelivery /> },
    ];

    const [activeStep,setActiveStep] = useState(1);

    const [branches, setBranches] = useState([]);


    useEffect(() => {
            apiService
                .getBranches()
                .then((response) => {
                    setBranches(response.data.map(({ id, name_ar, name_en }) => ({ id, name_ar, name_en })));
                })
                .catch((err) => {
                    console.error("Error fetching branches", err);
                });


    }, []);

    const [data, setData] = useState({
        fromLocation: "",
        toLocation: "",
        shipmentType: "",
        loadingDate: new Date().toISOString().split('T')[0],
        shipperName : "",
        shipperId : "",
        shipperPhone : "",
        sameAsRecipient : false,
        recipientName : "",
        recipientId : "",
        recipientPhone : "",
        ownerName : "",
        plateNumber : "",
        chassisNumber : "",
        vehicleType : "",
        vehicleModel : "",
        vehicleColor : ""

    });

    const [errors, setErrors] = useState({
        fromLocation: "",
        toLocation: "",
        vehicleSize: "",
        loadingDate: "",
        shipperName : "",
        shipperId : "",
        shipperPhone : "",
        sameAsRecipient : "",
        recipientName : "",
        recipientId : "",
        recipientPhone : "",
        ownerName : "",
        plateNumber : "",
        chassisNumber : "",
        vehicleType : "",
        vehicleModel : "",
        vehicleColor : ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        let isValid = true;

        if (!data.name) {
            newErrors.name = language === "ar" ? "الاسم مطلوب" : "Name is required";
            isValid = false;
        }

        if (data.email && !/\S+@\S+\.\S+/.test(data.email)) {
            newErrors.email = language === "ar" ? "البريد الالكتروني غير صالح" : "Email is invalid";
            isValid = false;
        }

        if (!data.phone) {
            newErrors.phone = language === "ar" ? "رقم الجوال مطلوب" : "Phone number is required";
            isValid = false;
        }

        if (!data.message) {
            newErrors.message = language === "ar" ? "الرسالة مطلوبة" : "Message is required";
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleNext = () => {
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const getStepStatusClass = (id) => {
        if (id === activeStep)
            return "bg-white text-primary-700 border-4 border-primary-700";
        else if ( id < activeStep)
            return "bg-primary-700 text-white";
        else  return "bg-white text-grayscale-400 border-4 border-grayscale-400";

    };
    const isPreviousStepCompleted = (index) => {
        return steps[index - 1] && steps[index - 1].id < activeStep;
    };

    const isPreviousStepActive = (index) => {
        return steps[index - 1] && steps[index - 1].id === activeStep;
    };

    return (
        <div className={`flex flex-col w-full ${direction === "rtl" ? "text-right" : "text-left"}`}>
            <div className="container flex  justify-center items-center overflow-x-scroll sm:overflow-x-hidden">

                {steps.map((step, index) => {
                    const isCompleted = step.id < activeStep;
                    const isActive = step.id === activeStep;
                    const isFirstStep = index === 0;
                    return (
                        <div key={step.id} className="flex items-center ">
                            {!isFirstStep  && (
                                <div className="flex flex-col items-center gap-y-8 sm:gap-y-4 sm:mb-28 mb-8">
                                    <div
                                        className={` lg:w-[130px] w-[52px] h-[30px] lg:h-[50px] whitespace-nowrap text-xs md:text-md ${
                                            isPreviousStepCompleted(index)
                                                ? "bg-primary-700 text-white"
                                                : isPreviousStepActive(index)
                                                    ? "border-2 border-primary-700 text-primary-700"
                                                    : "border-2 border-grayscale-400 text-grayscale-400"
                                        } rounded-lg inline-flex items-center justify-center font-bold`}
                                    >
                            <span>
                                {direction === 'rtl'
                                    ? isPreviousStepCompleted(index)
                                        ? "مكتمل"
                                        : isPreviousStepActive(index)
                                            ? "قيد التنفيذ"
                                            : "قيد الانتظار"
                                    : isPreviousStepCompleted(index)
                                        ? "Completed"
                                        : isPreviousStepActive(index)
                                            ? "In Progress"
                                            : "Pending"}
                            </span>
                                    </div>

                                    <div
                                        className={`w-full  transition-transform duration-300 ${
                                            direction === 'ltr' ? 'rotate-180' : 'rotate-0'
                                        }`}
                                    >
                                        {isPreviousStepCompleted(index) ? (
                                            <TrackingRedLine />
                                        ) : isPreviousStepActive(index) ? (
                                            <TrackingActiveLine />
                                        ) : (
                                            <TrackingGrayLine />
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className="flex flex-col items-center">
                                <div
                                    className={`cursor-pointer flex items-center justify-center lg:w-[100px] lg:h-[100px] w-[50px] h-[50px] rounded-full 
                                    ${getStepStatusClass(step.id)}`} onClick={() =>  setActiveStep(step.id)}
                                >
                                    {step.icon &&
                                        cloneElement(step.icon, {
                                            className: `${
                                                isCompleted
                                                    ? "text-white"
                                                    : isActive
                                                        ? "text-primary-700"
                                                        : "text-grayscale-400"
                                            } w-[25px] h-[25px] md:w-[40px] md:h-[40px] lg:w-[60px] lg:h-[60px]  `,
                                        })}
                                </div>
                                <div className="flex flex-col justify-center items-center">
                                    <div className="whitespace-nowrap text-xs sm:text-lg">{direction === "rtl" ? step.subtitle_ar : step.subtitle_en}</div>
                                    <div
                                        className={`${isCompleted || isActive ? "font-bold" : ""} ${
                                            isActive ? "text-primary-700" : ""
                                        }`}
                                    >
                                       <span className="whitespace-nowrap text-xs sm:text-lg">{direction === "rtl" ? step.title_ar : step.title_en}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

             {activeStep === 1 && (
                <BookingInfoStep1 data={data} errors={errors} branches={branches} handleInputChange={handleInputChange} handleNext={handleNext}/>
            )}

            {activeStep === 2 && (
                <SenderAndReceiverInfoStep2 data={data} errors={errors} handleInputChange={handleInputChange} handleNext={handleNext} handleBack={handleBack}/>
             )}

            {activeStep === 3 && (
               <VehicleInfoStep3 data={data} errors={errors} handleInputChange={handleInputChange} handleNext={handleNext} handleBack={handleBack} />
            )}
        </div>
    );
};

export default BookingForm;